import { Button } from "@msuite/ui/button";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { scrollIntoView } from "@msuite/ui/utils";
import type { ProtocolFormSchema } from "@msuite/utils/schemas";
import { generateId } from "@msuite/utils/strings";
import { useFormContext } from "react-hook-form";

export function ProtocolFormContentOptions() {
	/** Context */
	const methods = useFormContext<ProtocolFormSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Funcitons */
	function handleOnAddSection() {
		const newId = generateId();
		const currentContent = methods.getValues("content") || [];
		const newSection = {
			id: newId,
		};
		methods.setValue("content", [...currentContent, newSection]);
		scrollIntoView({ id: newId, timeout: 50 });
	}

	/** Render */
	return (
		<div className="h-stack justify-end">
			<Button
				icon={<Icon name="Plus" />}
				size="xxs"
				onClick={handleOnAddSection}
				data-cy="protocol-add-section-button"
			>
				{t("protocols.add_section")}
			</Button>
		</div>
	);
}
